import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { PageLoader } from "./PageLoader";

interface TeamRouteProps {
  children: ReactNode;
}

/**
 * Guard de route pour les pages réservées aux équipes.
 */
export const TeamRoute = ({ children }: TeamRouteProps) => {
  const { isAuthenticated, user, isLoading } = useAuthStore();

  if (isLoading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== "TEAM" && user?.role !== "ADMIN") {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

